var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1FBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 13.75C21.25 14.4403 20.6903 15 20 15C19.3097 15 18.75 14.4403 18.75 13.75C18.75 13.0596 20 11.6667 20 11.6667C20 11.6667 21.25 13.0596 21.25 13.75Z",
    stroke: "#003E3E",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V17.5",
    stroke: "#003E3E",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7222 21.6667C26.0262 21.6667 27.0833 20.7339 27.0833 19.5833C27.0833 18.4327 26.0262 17.5 24.7222 17.5H15.2778C13.9738 17.5 12.9167 18.4327 12.9167 19.5833C12.9167 20.7339 13.9738 21.6667 15.2778 21.6667C16.4201 21.6667 17.4201 20.9509 17.6389 20C17.8576 20.9509 18.8577 21.6667 20 21.6667C21.1422 21.6667 22.1423 20.9509 22.3611 20C22.5799 20.9509 23.5799 21.6667 24.7222 21.6667Z",
    stroke: "#003E3E",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 21.6667L14.6007 23.8163C15.0378 25.9807 15.2563 27.0628 15.9967 27.6981C16.7372 28.3333 17.7801 28.3333 19.8658 28.3333H20.1342C22.2199 28.3333 23.2628 28.3333 24.0032 27.6981C24.7437 27.0628 24.9622 25.9807 25.3992 23.8163L25.8333 21.6667",
    stroke: "#003E3E",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/Birthday.174d76272b045dc66fd64061273f6c8d.svg";
export { ForwardRef as ReactComponent };